import React from 'react';

export const InternationHolidayBanner = () => {
  return (
    // <div>
    //     <img src='Images/TravelImage6.jpg' alt='banner image'/>
    // </div>
    <div class="card text-bg-dark">
      <img src="Images/NewHomeLayout/Holidays/HolidayInnerBanners/domestic banner.png" class="card-img" alt="top banner image" />
        <div class="card-img-overlay">
          {/* <h5 class="card-title">Card title</h5>
          <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
          <p class="card-text"><small>Last updated 3 mins ago</small></p> */}
        </div>
    </div>
  )
}
